<template>
  <BContainer
    class="py-3"
  >
    <BRow>
      <BCol
        cols="12"
        class="py-3"
      >
        <BButton
          v-for="(variant, key) in buttons"
          :key="key"
          :variant="variant"
          class="mr-2"
        >
          COLORS
        </BButton>
      </BCol>
      <BCol
        cols="12"
        class="py-3"
      >
        <BButton
          v-for="(variant, key) in buttons"
          :key="key"
          :variant="variant"
          class="mr-2"
          disabled
        >
          COLORS
        </BButton>
      </BCol>
      <BCol
        cols="12"
        class="py-3"
      >
        <BButton
          v-for="(variant, key) in buttons"
          :key="key"
          :variant="`outline-${variant}`"
          class="mr-2"
        >
          COLORS
        </BButton>
      </BCol>

      <BCol
        cols="12"
        class="py-3"
      >
        <span
          v-for="(variant, key) in buttons"
          :key="key"
          :class="`mr-2 text-${variant}`"
        >
          COLORS
        </span>
      </BCol>

      <BCol
        cols="12"
        class="py-3"
      >
        <span
          v-for="(variant, key) in buttons"
          :key="key"
          :class="`mr-2 bg-${variant}-light p-2 rounded-lg text-dark`"
        >
          {{ variant }}
        </span>
      </BCol>

      <BCol
        cols="12"
        class="py-3"
      >
        <span
          v-for="(variant, key) in buttons"
          :key="key"
          :class="`mr-2 bg-${variant}-dark p-2 rounded-lg`"
        >
          {{ variant }}
        </span>
      </BCol>

    </BRow>
  </BContainer>
</template>
<script>
export default {

  name: 'UserDashboard',

  // middleware: ['auth', 'user'],
  middleware: ['guest'],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data: () => ({
    buttons: [
      'primary', 'secondary', 'success', 'warning', 'danger', 'info', 'dark', 'light'
    ],
    texts: [

    ]
  })
}
</script>
